var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid d-flex flex-wrap justify-content-between"},[_c('nav',[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/admin'}}},[_vm._v("Dashboard")])],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }